// Metronic (KTMenu/KTDrawer/KTToggle/KTScroll) mengikat instance-nya ke node DOM
// lewat KTUtil.data(element) dan hanya melakukannya sekali, saat DOMContentLoaded.
// Di aplikasi SPA ini React sering merender node tersebut jauh setelah itu
// (menunggu response API), sehingga node baru tidak pernah ter-bind dan komponen
// tema terlihat "mati" sampai halaman di-reload.
//
// Helper ini memanggil ulang createInstances() setelah React commit. Constructor
// tiap komponen KT sudah short-circuit kalau elemen punya instance, jadi
// pemanggilan berulang aman dan tidak menumpuk event handler.

const KT_GLOBALS = ['KTMenu', 'KTDrawer', 'KTToggle', 'KTScroll'];

const KT_SELECTOR = [
  '[data-kt-menu="true"]',
  '[data-kt-drawer="true"]',
  '[data-kt-toggle]',
  '[data-kt-scroll="true"]',
].join(',');

// Percobaan tambahan untuk node yang dirender beberapa saat setelah route berubah.
const DEFAULT_RETRY_DELAYS = [0, 150, 500];

export const initMetronicComponents = () => {
  KT_GLOBALS.forEach((name) => {
    try {
      window[name]?.createInstances?.();
    } catch {
      // abaikan error init tema agar tidak mematikan render React
    }
  });
};

// Jalankan init sekarang plus beberapa kali susulan. Mengembalikan fungsi cleanup
// supaya bisa dipakai langsung sebagai return value useEffect.
export const scheduleMetronicInit = (delays = DEFAULT_RETRY_DELAYS) => {
  const timers = delays.map((delay) => setTimeout(initMetronicComponents, delay));
  return () => timers.forEach(clearTimeout);
};

const containsKtNode = (mutations) =>
  mutations.some((mutation) =>
    Array.from(mutation.addedNodes).some(
      (node) =>
        node.nodeType === 1 && (node.matches?.(KT_SELECTOR) || node.querySelector?.(KT_SELECTOR))
    )
  );

// Pengaman utama: begitu ada node ber-atribut data-kt-* masuk ke DOM, bind ulang.
// Ini menghilangkan ketergantungan pada timing/tebakan delay untuk halaman yang
// merender menu setelah datanya datang.
export const observeMetronicNodes = (root = document.body) => {
  if (typeof MutationObserver === 'undefined' || !root) return () => {};

  let frame = null;

  const observer = new MutationObserver((mutations) => {
    if (frame !== null || !containsKtNode(mutations)) return;
    frame = window.requestAnimationFrame(() => {
      frame = null;
      initMetronicComponents();
    });
  });

  // Hanya childList: KT menulis atribut/class pada elemen saat init & saat menu
  // dibuka, jadi memantau atribut akan memicu loop.
  observer.observe(root, { childList: true, subtree: true });

  return () => {
    observer.disconnect();
    if (frame !== null) window.cancelAnimationFrame(frame);
  };
};
